import { render, staticRenderFns } from "./smslist.vue?vue&type=template&id=52626034&"
import script from "./smslist.vue?vue&type=script&lang=ts&"
export * from "./smslist.vue?vue&type=script&lang=ts&"
import style0 from "./smslist.vue?vue&type=style&index=0&id=52626034&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports